(() => {
  const SELECTOR = '[data-ks-social-proof]';

  const initialize = (section) => {
    if (!section || section.dataset.ksSocialProofInitialized === 'true') return;

    const track = section.querySelector('[data-ks-social-proof-track]');
    const region = section.querySelector('[data-ks-social-proof-region]');
    const cards = Array.from(section.querySelectorAll('[data-ks-social-proof-card]'));
    const navigation = section.querySelector('[data-ks-social-proof-navigation]');
    const previous = section.querySelector('[data-ks-social-proof-prev]');
    const next = section.querySelector('[data-ks-social-proof-next]');
    const current = section.querySelector('[data-ks-social-proof-current]');

    if (!track || !region || cards.length < 2 || !navigation || !previous || !next) return;

    section.dataset.ksSocialProofInitialized = 'true';
    let activeIndex = 0;
    let frame;

    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const hasOverflow = () => track.scrollWidth > track.clientWidth + 2;

    const nearestIndex = () => {
      const trackStart = track.getBoundingClientRect().left;
      return cards.reduce((nearest, card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - trackStart);
        return distance < nearest.distance ? { index, distance } : nearest;
      }, { index: 0, distance: Infinity }).index;
    };

    const update = () => {
      frame = undefined;
      const overflow = hasOverflow();
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

      navigation.hidden = !overflow;
      region.dataset.scrollStart = String(!overflow || track.scrollLeft <= 2);
      region.dataset.scrollEnd = String(!overflow || track.scrollLeft >= maxScroll - 2);

      if (!overflow) return;

      activeIndex = nearestIndex();
      previous.disabled = activeIndex === 0;
      next.disabled = activeIndex === cards.length - 1;
      if (current) current.textContent = String(activeIndex + 1);
    };

    const scheduleUpdate = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };

    const goTo = (index) => {
      const target = cards[Math.max(0, Math.min(index, cards.length - 1))];
      if (!target) return;
      target.scrollIntoView({
        behavior: reducedMotion() ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    };

    previous.addEventListener('click', () => goTo(activeIndex - 1));
    next.addEventListener('click', () => goTo(activeIndex + 1));
    track.addEventListener('scroll', scheduleUpdate, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      goTo(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(scheduleUpdate);
      observer.observe(track);
      cards.forEach((card) => observer.observe(card));
    } else {
      window.addEventListener('resize', scheduleUpdate, { passive: true });
    }

    update();
  };

  const initializeWithin = (root = document) => {
    if (root.matches?.(SELECTOR)) initialize(root);
    root.querySelectorAll?.(SELECTOR).forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin());
  } else {
    initializeWithin();
  }

  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
